import React, { createContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import _path from 'ramda/src/path';
import GeneralUtility from '../../utilities/generalUtility';
import GroupsAndFirms from '../../API/GroupsAndFirms';

const GroupContext = createContext();

const GroupProvider = ({ page, children }) => {
    const { groupuniquename } = useParams();
    const [currentGroup, setCurrentGroup] = useState(null);

    const pendingRequests = [];

    useEffect(() => {
        return () => {
            GeneralUtility.cleanupRequests(pendingRequests);
        };
    }, []);

    useEffect(() => {
        if ((groupuniquename && page === 'group') || page === 'local') {
            let g;

            if (page === 'local') {
                g = 'local';
            } else {
                g = groupuniquename;
            }

            const groupInfo = GroupsAndFirms.groupInfo(g);
            GeneralUtility.appendPendingRequest(pendingRequests, groupInfo);

            groupInfo.request
                .then(response => {
                    setCurrentGroup(_path(['data'], response));
                })
                .catch(error => {
                    GeneralUtility.logWebRequestFailure(error, `fetch group info from GroupContext.js`);
                    setCurrentGroup('error');
                });
        }
    }, [page, groupuniquename]);

    /* GroupUserType Owner = 0, User = 1, GuestUser = 2, not a user = null */
    const isGroupMember = () =>
        currentGroup && (currentGroup.IsFirm || currentGroup.GroupUserType === 0 || currentGroup.GroupUserType === 1);

    const isGroupGuest = () => currentGroup && currentGroup.GroupUserType === 2;

    const isUltimateOnlyGroup = () =>
        currentGroup && currentGroup.GroupSubtype === 4 && currentGroup.ConfigurationFlags.UltimateOnly;

    const contextValue = {
        currentGroup,
        isGroupMember,
        isGroupGuest,
        isUltimateOnlyGroup
    };

    return <GroupContext.Provider value={contextValue}>{children}</GroupContext.Provider>;
};

export { GroupProvider, GroupContext };
